import * as React from 'react';
import { useState } from 'react';
import ShopifyProduct from '../../interface/ShopifyProduct';
import IconHeart from '../Icons/IconHeart';
import ResponsiveImage from '../Core/ResponsiveImage';
import FavouriteProductButton from '../Favourites/FavouriteProductButton';
import Price, { MoneyFormat } from './Price';
import Badge, { BadgeProps } from './Badge';

export interface ProductCardProps {
    product?: ShopifyProduct | null;
    productHandle?: string;
    moneyFormat: MoneyFormat;
}
interface ProductImageProps {
    product: ShopifyProduct;
}

let counter = 0;

const ProductImage = (props: ProductImageProps) => {
    const { product } = props;
    if (product.images.length > 1) {
        return (
            <a href={product.url}>
                <ResponsiveImage
                    counter={counter++}
                    image={product.images[0]}
                    maxWidth={1000}
                    maxHeight={1200}
                />
                {product.images.length > 1 && (
                    <div className="product-card__alternative-image">
                        <ResponsiveImage
                            counter={counter++}
                            image={product.images[1]}
                            maxWidth={710}
                            maxHeight={852}
                        />
                    </div>
                )}
            </a>
        );
    }
    return <></>;
};
const ProductCard = (props: ProductCardProps) => {
    const { productHandle, moneyFormat } = props;
    let [product, setProduct] = useState(props.product);

    if (!product && productHandle) {
        fetch(`/products/${productHandle}?view=json`, { cache: 'force-cache' })
            .then(response => { 
                return response.json();
            })
            .then(data => {
                if (data.handle) {
                    product = data;
                    if (product)
                    setProduct(product);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });;
    }
    if (!product) {
        return (
            <div className="product-card product-card--loading">Loading...</div>
        );
    }
    const isBadgeActive = product.metafields && product.metafields.custom_fields && product.metafields.custom_fields.badge_text && product.metafields.custom_fields.badge_text !== '';
    return (
        <div className="product-card">
            <div className="product-card__image">
                <ProductImage product={product} />
                { isBadgeActive && <Badge
                    title={product.metafields.custom_fields.badge_text}
                    textColor={ product.metafields.custom_fields.badge_text_colour ? product.metafields.custom_fields.badge_text_colour : '#FFFFFF' }
                    backColor={ product.metafields.custom_fields.badge_background_colour ? product.metafields.custom_fields.badge_background_colour : '#000000' }
                    extraClasses="collection"
                />}
                <FavouriteProductButton productHandle={product.handle} />
            </div>
            <div className="product-card__details">
                <a href={product.url} className="product-card__link">
                    <h3 className="product-card__title">{product.title}</h3>
                    <div className="product-card__price">
                        <Price
                            productId={product.id}
                            price={product.price_min}
                            compareAtPrice={product.compare_at_price_min}
                            moneyFormat={moneyFormat}
                        />
                    </div>
                    {product.metafields &&
                        product.metafields.custom_fields['short_description'] !=
                            '' && (
                            <div className="product-card__description">
                                {
                                    product.metafields.custom_fields[
                                        'short_description'
                                    ]
                                }
                            </div>
                        )}
                </a>
            </div>
        </div>
    );
};
export default ProductCard;
